import { useRouteError, isRouteErrorResponse, useNavigate } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export default function ErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();

  let title = "Something went wrong";
  let detail = "An unexpected error occurred. Please try again.";

  if (isRouteErrorResponse(error)) {
    // Thrown Response, e.g. throw new Response("Not Found", { status: 404 })
    title = `${error.status} ${error.statusText}`;
    detail = error.data?.message || detail;
  } else if (error instanceof Error) {
    detail = error.message;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      sx={{ minHeight: "60vh", p: 3 }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 56, color: "error.main", mb: 2 }} />
      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3, maxWidth: 480 }}>
        {detail}
      </Typography>
      <Box display="flex" gap={2}>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          Go back
        </Button>
        <Button variant="contained" color="primary" onClick={() => navigate("/calendar")}>
          Back to dashboard
        </Button>
      </Box>

      {process.env.NODE_ENV === "development" && error instanceof Error && (
        <Box
          component="pre"
          sx={{
            mt: 4, p: 2, textAlign: "left", overflow: "auto", maxWidth: "100%",
            bgcolor: "grey.100", borderRadius: 1, fontSize: 12,
          }}
        >
          {error.stack}
        </Box>
      )}
    </Box>
  );
}